import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=64ad4917"
import script from "./activity.vue?vue&type=script&lang=js"
export * from "./activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ad4917')) {
      api.createRecord('64ad4917', component.options)
    } else {
      api.reload('64ad4917', component.options)
    }
    module.hot.accept("./activity.vue?vue&type=template&id=64ad4917", function () {
      api.rerender('64ad4917', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/activity/activity.vue"
export default component.exports